/**
 * This method allows debouncing a function based on its arguments.
 *
 * @param func
 * @param wait
 * @param options
 * @returns {Function}
 */
export const memoizeDebounce = function(func, wait = 0, options = {}) {
  var mem = _.memoize(function() {
    return _.debounce(func, wait, options);
  }, options.resolver);
  return function() {
    mem.apply(this, arguments).apply(this, arguments);
  };
};

/**
 * Get Color Variant for Progress Bar
 * @param rate
 */
export const getColorVariant = function(rate) {
  if (rate > 92) {
    return "success";
  } else if (85 < rate && rate < 92) {
    return "warning";
  } else {
    return "danger";
  }
};

export const getFileTypeClass = function(mimeType) {
  const map = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/svg": "svg",
    "image/xml+svg": "svg",
    "application/pdf": "pdf",
    "text/csv": "csv",
    "application/zip": "zip",
    "text/plain": "txt",
    "application/ppt": "ppt",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xls",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "ppt"
  };

  return map[mimeType] !== undefined ? map[mimeType] : "unknown";
};
